/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Address } from './Address';
export type RegisterPublicSeminarAsClientPayload = {
    paymentType?: RegisterPublicSeminarAsClientPayload.paymentType;
    fingerprint: string;
    phoneNumber?: string;
    address?: Address;
    seats?: number;
    note?: string;
    source?: RegisterPublicSeminarAsClientPayload.source;
};
export namespace RegisterPublicSeminarAsClientPayload {
    export enum paymentType {
        ONLINE = 'online',
        CASH = 'cash',
        INVOICE = 'invoice',
    }
    export enum source {
        WIDGET = 'widget',
        PUBLIC_PAGE = 'public_page',
    }
}

